<template>
    <div>
         <Form :model="formItem" :label-width="65" ref="formItemSearch">
            <Row>
                <Col span="24">
                    <Col span="4">
                        <FormItem label="部门名称" prop="name">
                            <Input v-model="formItem.name" placeholder="请输入" @keydown.native.enter.prevent="search"></Input>
                        </FormItem>
                    </Col>
                    <Col span="4">
                        <FormItem label="开放门店" prop="store_id">
                            <Select v-model="formItem.store_id" placeholder="请选择">
                                <Option v-for="item in storeList" :key="item.id" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="16">
                        <Button type="primary" style="margin-left:5px" @click="search">查询</Button>
                        <Button type="primary" @click="reset('formItemSearch')">清空筛选</Button>
                        <Button type="primary" @click="add">添加</Button>
                    </Col>
                </Col>
            </Row>
        </Form>
        <div style="width:100%">
            <Table ref="table" stripe :loading="loading" border :columns="t_columns" :data="t_data" :height="tableHeight"></Table>
            <div style="margin-top:20px;display:flex;justify-content:flex-end">
                <Page :total="pagination.total" :page-size="pagination.per_page" show-total show-elevator show-sizer  @on-page-size-change="changeLimit"  @on-change="pageChange" :transfer="true" :page-size-opts="pageSizeOpts"/>
            </div>
        </div>
        <Modal
            v-model="ModalShow"
            :title="title"
            >
            <Form ref="formValidate" :model="editFormItem" :rules="ruleValidate" :label-width="80">
                <FormItem label="部门名称" prop="name">
                    <Input v-model="editFormItem.name" placeholder="请输入"></Input>
                </FormItem>
                <FormItem label="开放门店" prop="store_id">
                    <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
                        <Checkbox
                            :indeterminate="indeterminate"
                            :value="checkAll"
                            @click.prevent.native="handleCheckAll">全选</Checkbox>
                    </div>
                    <CheckboxGroup v-model="editFormItem.store_id" @on-change="checkAllGroupChange">
                        <Checkbox v-for="item in storeList" :key="item.id" :label="item.id">{{item.name}}</Checkbox>
                    </CheckboxGroup>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="close">取消</Button>
                <Button type="primary" size="large" @click="handleSubmit ('formValidate')">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:'departmentSetting',
    data(){
        return{
            tableHeight: 500,
            pageSizeOpts:[50,60,70,80,90,100],
            loading:false,
            ModalShow:false,
            listDetailId:0,
            title:"",
            formItem:{
                name:"",
                store_id:"",
                page:1,
                limit:50,
            },
            editFormItem:{
                name:'',
                store_id: [],
            },
            ruleValidate:{
                name: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                store_id: [
                    { required: true, type: 'array', min: 1, message: '请选择', trigger: 'change' },
                ],
            },
            indeterminate: true,
            checkAll: false,
            t_columns: [
                {
                    width: 60,
                    align: 'center',
                    title:"序号",
                    render: (h,params) => {
                        return h('span',
                        (params.index + 1) + (this.pagination.per_page * (this.pagination.current_page-1)))
                    }
                },
                {
                    title: '部门名称',
                    key: 'name',
                    align: 'center',
                },
                {
                    title: '开放门店',
                    key: 'store',
                    align: 'center',
                    render:(h,params) =>{
                        let str = params.row.store.join("，")
                        return h('div',[
                            h('div',{},str)
                        ])
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.edit(params.row.id)
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.remove(params.row.id)
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                }
            ],
            t_data: [],
            pagination:{},
            listDetailData:{},
            storeList:[]
        }
    },
    created(){
        this.apiStoreAll()
        this.apiDepartmentList()
    },
    mounted(){
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 205
    },
    methods:{
        changeLimit(val){
            this.formItem.limit=val
            this.apiDepartmentList()
        },
        add(){
            this.$refs.formValidate.resetFields()
            this.title = '添加部门'
            this.indeterminate = false;
            this.checkAll = false;
            this.ModalShow = true
        },
        edit(id){
            this.$refs.formValidate.resetFields()
            this.title = '编辑部门'
            this.listDetailId = id
            this.ModalShow = true
            this.apiDepartmentDetail(id)
        },
        remove(id){
            this.apiDepartmentRemove(id)
        },
        apiStoreAll(){
            serve.fetchGet(api.departmentStore,{}).then(data => {
                console.log(data)
                this.storeList = data.data
                
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiDepartmentList(){
            this.loading = true
            serve.fetchGet(api.department,this.formItem).then(data => {
                console.log(data)
                this.t_data = data.data
                this.pagination = data.meta.pagination
                this.loading = false
            }).catch((error)=>{
                this.loading = false
                this.$Message.error(error.response.data.message);
            })
        },
        apiDepartmentAdd(){
            serve.fetchPost(api.department,this.editFormItem).then(data => {
                console.log(data)
                this.$Message.success('添加成功');
                this.ModalShow = false
                this.apiDepartmentList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiDepartmentDetail(id){
            serve.fetchGet(api.department+'/'+id,{}).then(data => {
                console.log(data)
                this.listDetailData = data.data
                this.editFormItem.name=data.data.name
                this.editFormItem.store_id=data.data.store_id
                this.checkAllGroupChange(data.data.store_id)
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiDepartmentEdit(){
            serve.fetchPut(api.department+"/"+this.listDetailId,this.editFormItem).then(data => {
                console.log(data)
                this.$Message.success('修改成功');
                this.ModalShow = false
                this.apiDepartmentList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiDepartmentRemove(id){
            serve.fetchDelete(api.department+'/'+id,{}).then(data => {
                console.log(data)
                this.$Message.success('删除成功');
                this.apiDepartmentList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        handleCheckAll () {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;

            if (this.checkAll) {
                let getStoreId = []
                for(let item of this.storeList){
                    getStoreId.push(item.id)
                }
                this.editFormItem.store_id = getStoreId;
            } else {
                this.editFormItem.store_id = [];
            }
        },
        checkAllGroupChange (data) {
            console.log(data)
            if (data.length === this.storeList.length) {
                this.indeterminate = false;
                this.checkAll = true;
            } else if (data.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            } else {
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        close(){
            this.ModalShow = false
        },
        handleSubmit(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if(this.title === "添加部门"){
                        this.apiDepartmentAdd()
                        return
                    }
                    this.apiDepartmentEdit()
                } else {
                    this.$Message.error('请完善表单');
                }
            })
        },
        pageChange(page){
            this.formItem.page = page
            this.apiDepartmentList()
        },
        search(){
            this.formItem.page = 1
            this.apiDepartmentList()
        },
        reset(name){
            this.formItem.page = 1
            this.$refs[name].resetFields()
            this.apiDepartmentList()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/SystemSetting/System/departmentSetting.vue